import { Button, Center, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { getCdcWebSignupLink } from '@/utils'

import styles from './styles.module.css'

export default function FavoritesTabView() {
  const t = useTranslations('coinTable')
  return (
    <Center className={`${styles.container} absolute-cover`}>
      <Stack align="center" gap={16}>
        <Text variant="heading2" c="var(--content-primary)">
          {t('signUpToCreateFavorites')}
        </Text>
        <Text variant="heading3" c="var(--content-secondary)">
          {t('Save tokens you want to keep track of')}
        </Text>
        <Button variant="filled-primary" component="a" href={getCdcWebSignupLink()} w="fit-content">
          <Text variant="body-emphasis" c="var(--common-white)">
            {t('getStarted')}
          </Text>
        </Button>
      </Stack>
    </Center>
  )
}
